import { render, staticRenderFns } from "./RecessConfigList.vue?vue&type=template&id=3b37aeec&scoped=true"
import script from "./RecessConfigList.vue?vue&type=script&lang=js"
export * from "./RecessConfigList.vue?vue&type=script&lang=js"
import style0 from "./RecessConfigList.vue?vue&type=style&index=0&id=3b37aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37aeec",
  null
  
)

export default component.exports